import React from "react";
import Reveal from "../Reveal";
import { badges } from "../../lib/home-content";

const BadgesSection = () => (
  <section className="bg-[#F4F7FE] border-t border-[#DCE4F2]">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-20">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        {badges.map((b, i) => {
          const Icon = b.icon;
          return (
            <Reveal
              key={b.title}
              delay={i * 120}
              data-testid={`badge-${i}`}
              className="bg-white border border-[#DCE4F2] p-8 md:p-10 relative group hover:border-[#4A3FCF] transition-colors"
            >
              <div className="absolute -top-5 left-8 w-12 h-12 bg-[#0F1245] flex items-center justify-center group-hover:bg-[#4A3FCF] transition-colors">
                <Icon size={20} strokeWidth={1.6} className="text-white" />
              </div>
              <h3 className="font-serif-display text-2xl md:text-3xl mt-6 text-[#0F1245]">{b.title}</h3>
              <p className="text-[14px] text-[#5A5F7A] mt-3 leading-relaxed">{b.body}</p>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default BadgesSection;
